module.exports = __webpack_public_path__ + "static/media/N7.7ef2e047.png";